<template>
  <div class="clinic-cf-page">
    <el-row :gutter="18" class="cf-stat-row">
      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="cf-stat-card cf-stat-card--today" shadow="hover">
          <div class="cf-stat-inner">
            <div class="cf-stat-value numClass cf-stat-value--accent">{{ kf_today }}</div>
            <div class="cf-stat-label hintClass">今日开方量</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="cf-stat-card" shadow="hover">
          <div class="cf-stat-inner">
            <div class="cf-stat-value numClass">{{ kf_yesterday }}</div>
            <div class="cf-stat-label hintClass">昨日开方量</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="cf-stat-card" shadow="hover">
          <div class="cf-stat-inner">
            <div class="cf-stat-value numClass">{{ kf_this_week_vs_last_week }}</div>
            <div class="cf-stat-label hintClass">上周开方量</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" :xs="24" :sm="12" :md="6">
        <el-card class="cf-stat-card" shadow="hover">
          <div class="cf-stat-inner">
            <div class="cf-stat-value numClass">{{ kf_this_week_vs_last_month }}</div>
            <div class="cf-stat-label hintClass">上月开方量</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="cf-chart-wrap">
      <LineChart
        id="pres_trend"
        path="clinic_pres_trend"
        chart_type="line"
        height="400px"
        :params='{"clinic_id":clinic_id}'
      />
    </div>

    <div v-if="this.prop_clinic_id!='-1'" class="cf-table-panel">
      <el-row :gutter="16" class="cf-table-row">
        <el-col :span="24">
          <el-table
            class="cf-detail-table"
            :data="clinic_pre_by_doctor"
            :header-cell-style="{background:'#363944',color:'white',border:'none'}"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="index" label="序号"></el-table-column>
            <el-table-column prop="doctor_name" label="医生姓名"></el-table-column>
            <el-table-column prop="doctor_id" label="doctor_id" v-if="false"></el-table-column>
            <el-table-column prop="cnt" label="开方量"></el-table-column>
            <el-table-column prop="月份" label="时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  class="cf-detail-link"
                  type="text"
                  size="small"
                  @click="open_detail(scope.row)"
                >
                  处方详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="处方列表"
      :visible.sync="dialogFormVisible"
      width="70%"
      append-to-body
      custom-class="clinic-cf-dialog"
    >
      <div v-if="doctor_mr_brief_data&&doctor_mr_brief_data.length>0" class="cf-dialog-body">
        <div class="cf-dialog-swiper-toolbar">
          <div class="cf-rx-carousel" role="group" aria-label="处方病历切换">
            <div class="cf-rx-arrow-col">
              <button
                type="button"
                class="cf-rx-arrow cf-rx-arrow--prev"
                aria-label="上一份处方"
                @click="cfRxSwiperPrev"
              />
            </div>
            <div class="cf-rx-swiper-viewport">
              <swiper ref="cfRxSwiper" class="swiper cf-rx-swiper-inner" :options="swiperOption">
                <swiper-slide
                  v-for="(item, index) in doctor_mr_brief_data"
                  :key="item.mr_id || ('idx-' + index)"
                  class="swiper-slide-item"
                  :class="{ 'swiper-slide-selected': item.mr_id === sel_mr_id }"
                >
                  <!-- class hello：set_mr_id 仍用 getElementsByClassName('hello')；swiper-card 与 Basic 电子处方卡片一致 -->
                  <div
                    :id="'div_'+item.mr_id"
                    class="hello swiper-card"
                    role="button"
                    tabindex="0"
                    @click="set_mr_id(item.mr_id)"
                  >
                    <div class="swiper-card-title">{{ item.mr_diagnosis }}</div>
                    <div class="swiper-card-time">{{ item.mr_visit_time }}</div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="cf-rx-arrow-col">
              <button
                type="button"
                class="cf-rx-arrow cf-rx-arrow--next"
                aria-label="下一份处方"
                @click="cfRxSwiperNext"
              />
            </div>
          </div>
        </div>
        <div class="cf-dialog-detail">
          <MedicalRecordDetail
            :mr_id="this.sel_mr_id"
            :clinic_profile_data="clinic_profile_data"
            :key="this.sel_mr_id"
            :rowData="rowData"
            :dataItem="doctor_mr_brief_data"
          />
        </div>
      </div>
      <div v-else class="cf-dialog-empty">
        <el-empty description="暂无数据" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LineChart from "@/views/charts/line";
import '@/assets/css/main.css';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import MedicalRecordDetail from "@/views/patient/MedicalRecordDetail";

/**
 * 诊所业务开方量统计组件
 * 用于展示诊所的开方量统计、趋势图表和医生开方详情
 */
export default {
  name: "ClinicBusinessCF",
  components: {
    LineChart, // 折线图组件
    Swiper, // 轮播图组件
    SwiperSlide, // 轮播图子项组件
    MedicalRecordDetail, // 病历详情组件
  },
  props: {
    /**
     * 诊所ID（从父组件传入）
     */
    prop_clinic_id: {
      type: String,
      default: null,
    },
    /**
     * 医生ID（从父组件传入）
     */
    prop_doctor_id: {
      type: String,
      default: null,
    },
    /**
     * 诊所档案数据（从父组件传入）
     */
    clinic_profile_data: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      // 处方详情对话框显示状态
      dialogFormVisible: false,
      
      // 诊所ID：优先从路由参数获取，其次从localStorage，最后使用默认值
      clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : (localStorage.getItem('clinic_id') ? localStorage.getItem('clinic_id') : '4237'),
      
      // 医生ID：优先从路由参数获取，其次从props，最后使用默认值
      doctor_id: this.$route.query.doctor_id ? this.$route.query.doctor_id : (this.prop_doctor_id ? this.prop_doctor_id : '-1'),
      
      // 按医生统计的开方量数据
      clinic_pre_by_doctor: null,
      
      // 按医生统计的费用数据
      clinic_fee_by_doctor: null,

      // 费用相关统计数据
      fees_today: "0", // 今日费用
      fees_yesterday: "0", // 昨日费用
      fees_this_week_vs_last_week: "0", // 本周与上周费用对比
      fees_this_week_vs_last_month: "0", // 本周与上月费用对比

      // 开方量相关统计数据
      kf_today: "0", // 今日开方量
      kf_yesterday: "0", // 昨日开方量
      kf_this_week_vs_last_week: "0", // 本周与上周开方量对比
      kf_this_week_vs_last_month: "0", // 本周与上月开方量对比

      // Swiper 配置：与 Basic 电子处方横条一致（外链按钮翻页，不在内容上叠箭头）
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 14,
        slideToClickedSlide: true,
      },
      
      // 当前选中的病历ID
      sel_mr_id: 0,
      
      // 病历访问时间
      mr_visit_time: null,
      
      // 医生病历简要数据列表
      doctor_mr_brief_data: null,
      
      // 表格行数据
      rowData: null,
    }
  },
  /**
   * 组件挂载后执行
   * 初始化数据：获取开方量、费用和统计数据
   */
  mounted() {
    this.get_clinic_pre_by_doctor(); // 获取按医生统计的开方量
    this.get_clinic_fee_by_doctor(); // 获取按医生统计的费用
    this.get_clinic_stat(); // 获取诊所统计数据
    // this.load_doctor_mr_brief(); // 加载医生病历简要信息（已注释）
  },
  methods: {
    /**
     * 弹窗内处方横滑：取 Swiper 实例（与 Basic 一致，仅用于上一页/下一页）
     * @returns {object|null} vue-awesome-swiper 实例或 null
     */
    cfRxSwiperInstance() {
      const comp = this.$refs.cfRxSwiper;
      if (!comp) {
        return null;
      }
      return comp.swiper || comp.$swiper || null;
    },
    /**
     * 弹窗内：上一张处方卡片（只调用 slidePrev，不改变数据）
     */
    cfRxSwiperPrev() {
      const s = this.cfRxSwiperInstance();
      if (s) {
        s.slidePrev();
      }
    },
    /**
     * 弹窗内：下一张处方卡片（只调用 slideNext，不改变数据）
     */
    cfRxSwiperNext() {
      const s = this.cfRxSwiperInstance();
      if (s) {
        s.slideNext();
      }
    },
    /**
     * 设置选中的病历ID并更新样式
     * @param {Number} mr_id - 病历ID
     */
    set_mr_id(mr_id) {
      this.sel_mr_id = mr_id

      // 重置所有幻灯片的背景色为默认色
      let elements = document.getElementsByClassName("hello")
      for (let i = 0; i < elements.length; i++) {
        elements[i].parentElement.style.backgroundColor = "#42444F";
      }
      // 设置当前选中幻灯片的背景色为高亮色
      document.getElementById("div_" + mr_id).parentElement.style.backgroundColor = "#575350";
    },
    
    /**
     * 加载医生病历简要信息
     * @param {String} doctor_id - 医生ID
     * @param {String} mr_visit_time - 病历访问时间
     */
    load_doctor_mr_brief(doctor_id, mr_visit_time) {
      this.$http.get(process.env.VUE_APP_API_HOST + "/doctor_mr_brief?doctor_id=" + doctor_id + "&mr_visit_time=" + mr_visit_time).then((res) => {
        this.doctor_mr_brief_data = res.data.data
        // 如果有数据，默认选中第一条
        if (res.data.data.length > 0) {
          this.sel_mr_id = res.data.data[0].mr_id
        }
      })
    },
    
    /**
     * 打开处方详情对话框
     * @param {Object} row - 表格行数据对象
     */
    open_detail(row) {
      this.dialogFormVisible = true; // 显示对话框
      this.doctor_mr_brief_data = null // 清空之前的数据
      // 加载该医生在指定时间的病历简要信息
      this.load_doctor_mr_brief(row['doctor_id'], row['月份']);
      this.rowData = row; // 保存行数据
    },
    
    /**
     * 获取诊所统计数据
     * 包括今日/昨日费用、开方量及环比数据
     */
    get_clinic_stat() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_clinic_stat?clinic_id=" + this.clinic_id
          + "&doctor_id=" + this.doctor_id).then((res) => {

        // 处理费用数据
        this.fees_yesterday = res.data.data.fees_yesterday
        this.fees_today = res.data.data.fees_today
        
        // 计算今日费用较昨日的增长率
        var fees_compare_result = (100.0 * (this.fees_today - this.fees_yesterday) / this.fees_yesterday).toFixed(2)
        if (this.fees_yesterday == 0) {
          fees_compare_result = 0
        }
        // 格式化费用显示：添加环比信息
        if (fees_compare_result != 0) {
          this.fees_today = res.data.data.fees_today + "(较昨" + (fees_compare_result > 0 ? "↑" + fees_compare_result : "↓" + Math.abs(fees_compare_result)) + "%)"
        } else {
          this.fees_today = res.data.data.fees_today + "(与昨持平)"
        }
        this.fees_this_week_vs_last_week = res.data.data.fees_this_week_vs_last_week
        this.fees_this_week_vs_last_month = res.data.data.fees_this_week_vs_last_month

        // 处理开方量数据
        this.kf_today = res.data.data.kf_today
        this.kf_yesterday = res.data.data.kf_yesterday
        
        // 计算今日开方量较昨日的增长率
        let kf_compare_result = (100.0 * (this.kf_today - this.kf_yesterday) / this.kf_yesterday).toFixed(2)
        if (this.kf_yesterday == 0) {
          kf_compare_result = 0
        }
        // 格式化开方量显示：添加环比信息
        if (kf_compare_result != 0) {
          this.kf_today = res.data.data.kf_today + "(较昨" + (kf_compare_result > 0 ? "↑" + kf_compare_result : "↓" + Math.abs(kf_compare_result)) + "%)"
        } else {
          this.kf_today = res.data.data.kf_today + "(与昨持平)"
        }

        this.kf_this_week_vs_last_week = res.data.data.kf_this_week_vs_last_week
        this.kf_this_week_vs_last_month = res.data.data.kf_this_week_vs_last_month

        // 更新诊所信息
        this.clinic_name = res.data.data.clinic_name
        this.clinic_id = res.data.data.clinic_id
      })
    },

    /**
     * 获取按医生统计的开方量详情
     */
    get_clinic_pre_by_doctor() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/clinic_pre_detail?clinic_id=" + this.clinic_id
          + "&doctor_id=" + this.doctor_id).then((res) => {
        this.clinic_pre_by_doctor = res.data.data
      })
    },
    
    /**
     * 获取按医生统计的费用详情
     */
    get_clinic_fee_by_doctor() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/clinic_fees_detail?clinic_id=" + this.clinic_id
          + "&doctor_id=" + this.doctor_id).then((res) => {
        this.clinic_fee_by_doctor = res.data.data
      })
    },
    
    /**
     * 表格行样式类名生成函数
     * 用于实现表格行的斑马纹效果
     * @param {Object} param0 - 包含row和rowIndex的对象
     * @param {Object} param0.row - 当前行数据
     * @param {Number} param0.rowIndex - 当前行索引
     * @returns {String} 返回样式类名
     */
    tableRowClassName({ rowIndex }) {
      // 奇数行返回 warning-row1，偶数行返回 success-row1
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
}
</script>

<style scoped>
/**
 * 诊所处方：KPI、趋势图、表格与弹窗内病历轮播的样式（不改 script 中接口与 set_mr_id 逻辑；保留 class hello）
 */

.clinic-cf-page {
  width: 100%;
  box-sizing: border-box;
  padding: 4px 0 8px;
  margin: 0;
}

.cf-stat-row {
  margin: 0 !important;
}

.cf-stat-row :deep(.el-col) {
  margin-bottom: 14px;
}

.cf-stat-card {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(165deg, #464a54 0%, #363944 100%);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.14);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  text-align: center;
}

.cf-stat-card:hover {
  border-color: rgba(104, 245, 185, 0.22);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
}

.cf-stat-card--today {
  border-color: rgba(255, 138, 128, 0.35);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(255, 120, 100, 0.12);
}

.cf-stat-card :deep(.el-card__body) {
  padding: 16px 14px 18px;
  background: transparent;
}

.cf-stat-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 72px;
}

.cf-stat-value.numClass {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
  color: #f2f4f8;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
}

.cf-stat-value--accent {
  color: #ff9a8e !important;
}

.cf-stat-label.hintClass {
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.8;
  margin: 0;
}

.cf-chart-wrap {
  margin-top: 8px;
  margin-bottom: 10px;
  padding: 14px 16px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  min-height: 400px;
}

.cf-table-panel {
  margin-top: 6px;
  width: 100%;
  box-sizing: border-box;
}

.cf-table-row {
  margin: 0 !important;
  width: 100%;
}

.cf-detail-table {
  width: 100%;
}

.cf-detail-link {
  color: #68f5b9 !important;
  font-weight: 600;
  padding: 0 !important;
}

.cf-detail-link:hover {
  color: #9cf5d1 !important;
}

.chart-container {
  position: relative;
  width: 100%;
  height: 200px;
}

.cf-detail-table :deep(tbody tr:hover) {
  color: black !important;
}

.cf-detail-table :deep(.warning-row1) {
  background: #363944;
}

.cf-detail-table :deep(.warning-row1 > td) {
  border: none;
}

.cf-detail-table :deep(.success-row1) {
  background: #3c3f4a;
}

.cf-detail-table :deep(.success-row1 > td) {
  border: none;
}

.cf-dialog-body {
  max-height: min(80vh, 720px);
  overflow-y: auto;
}

/* 弹窗内处方横条：与 Basic.vue 电子处方「病历切换」同一套布局与卡片样式 */
.cf-dialog-swiper-toolbar {
  margin-bottom: 14px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}

.cf-rx-carousel {
  display: flex;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  gap: 0;
}

.cf-rx-arrow-col {
  flex: 0 0 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cf-rx-swiper-viewport {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  padding: 0 6px;
  box-sizing: border-box;
}

.cf-rx-arrow {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.cf-rx-arrow:hover {
  background: rgba(104, 245, 185, 0.12);
  border-color: rgba(104, 245, 185, 0.35);
  color: #b8ffe0;
}

.cf-rx-arrow:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(104, 245, 185, 0.35);
}

.cf-rx-arrow::after {
  content: '';
  display: block;
  width: 7px;
  height: 7px;
  margin: 0 auto;
  border: solid currentColor;
  border-width: 0 2px 2px 0;
}

.cf-rx-arrow--prev::after {
  transform: translateX(2px) rotate(135deg);
}

.cf-rx-arrow--next::after {
  transform: translateX(-2px) rotate(-45deg);
}

/* 覆盖 set_mr_id 写在 slide 上的行内背景，选中态改由卡片 class 与 Basic 一致 */
.cf-rx-swiper-viewport :deep(.swiper-slide) {
  background: transparent !important;
}

.cf-rx-swiper-viewport :deep(.swiper-container) {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
  overflow: hidden !important;
}

.cf-rx-swiper-viewport :deep(.swiper-wrapper) {
  box-sizing: border-box;
}

.swiper.cf-rx-swiper-inner,
.cf-rx-swiper-inner {
  width: 100%;
  max-width: 100%;
}

.cf-dialog-swiper-toolbar :deep(.swiper) {
  height: auto;
  min-height: 56px;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.cf-dialog-swiper-toolbar :deep(.swiper .swiper-slide) {
  display: flex;
  justify-content: center;
  align-items: stretch;
  text-align: left;
  font-weight: 500;
  font-size: 12px;
  background: transparent;
  cursor: pointer;
  flex-direction: column;
  height: auto;
  border-radius: 6px;
}

.cf-dialog-swiper-toolbar .swiper-slide-item {
  box-sizing: border-box;
  height: auto;
}

.cf-dialog-swiper-toolbar .swiper-slide-item .swiper-card {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: none;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.cf-dialog-swiper-toolbar .swiper-slide-item .swiper-card:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.14);
}

.cf-dialog-swiper-toolbar .swiper-slide-selected .swiper-card {
  background: rgba(104, 245, 185, 0.22);
  border: 1px solid rgba(104, 245, 185, 0.72);
  box-shadow: inset 3px 0 0 #68f5b9;
}

.cf-dialog-swiper-toolbar .swiper-slide-selected .swiper-card-title {
  color: #fff;
}

.cf-dialog-swiper-toolbar .swiper-slide-selected .swiper-card-time {
  color: rgba(255, 255, 255, 0.6);
}

.cf-dialog-swiper-toolbar .swiper-card-title {
  color: #eceef2;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
}

.cf-dialog-swiper-toolbar .swiper-card-time {
  color: rgba(255, 255, 255, 0.42);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
}

.cf-dialog-detail {
  margin-top: 4px;
}

.cf-dialog-empty {
  padding: 32px 16px;
}
</style>
